/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'

import { useSortable } from '@dnd-kit/react/sortable'
import { closestCenter, CollisionDetector } from '@dnd-kit/collision'
import { RestrictToVerticalAxis } from '@dnd-kit/abstract/modifiers'
import { RestrictToElement } from '@dnd-kit/dom/modifiers'
import { Modifiers } from '@dnd-kit/abstract'

import type { SortableWrapperProps } from './utils/types.ts'
import { getDragWrapperStyle } from './utils/drag-helpers.ts'

function SortableWrapper(props: SortableWrapperProps) {
    const { id, index, offset, children, type } = props

    let groupName
    let container
    let maxSliderWidth
    let bottomMostYVal

    const isHoriz = ['player', 'player-modal'].includes(type)

    if (type === 'stat') {
        ;({ groupName, container } = props)
    } else if (type === 'player') {
        ;({ maxSliderWidth, bottomMostYVal } = props)
    }

    const useSortableArgs: {
        id: string
        index: number
        group: string | undefined
        collisionDetector: CollisionDetector
        modifiers?: Modifiers
    } = {
        id,
        index,
        group: type === 'stat' ? groupName : `sortable-${type}-list`,
        collisionDetector: closestCenter,
    }

    if (type === 'stat') {
        useSortableArgs.modifiers = [
            RestrictToVerticalAxis,
            RestrictToElement.configure({
                element: container,
            }),
        ]
    }

    const { ref, handleRef, isDragging, isDropping } =
        useSortable(useSortableArgs)

    const xOffset = isHoriz ? offset : 0
    const yOffset = isHoriz ? 0 : offset

    const style = getDragWrapperStyle(
        isDragging,
        isDropping,
        isHoriz,
        xOffset,
        yOffset
    )

    return (
        <g
            ref={ref}
            // transform={`translate(${xOffset}, ${yOffset})`}
            style={style}
        >
            {isDragging && type === 'player' && (
                <rect
                    width={maxSliderWidth! + 10} // Padding around the player
                    height={bottomMostYVal! + 20}
                    x={-5}
                    y={0}
                    fill={isDragging ? 'white' : 'transparent'}
                    fillOpacity={0.9}
                    rx={8}
                />
            )}
            <g ref={handleRef}>{children}</g>
        </g>
    )
}

export default SortableWrapper
